var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.timezoneStr)?_c('span',{class:("" + _vm.name)},[_vm._v("\n  "+_vm._s(_vm.hideLabel ? _vm.timezoneStr : _vm.$t('adgroup_budget_timezone', { timezone: _vm.timezoneStr }))+"\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }